import { render, staticRenderFns } from "./GerenciarUsuarios.vue?vue&type=template&id=06acb08e&scoped=true"
import script from "./GerenciarUsuarios.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06acb08e",
  null
  
)

export default component.exports